<form [formGroup]="form" *ngIf="form">
  <div [dir]="data.dir" class="row">
    <div class="col-sm-12 mb-2">
      <mat-label class="font-weight-bold field-required">
        {{ "forms.common.Criteria.clause" | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" formControlName="clause"></textarea>
      </mat-form-field>
    </div>

    <div class="col-sm-6">
      <mat-label class="font-weight-bold field-required">
        {{ "forms.common.Criteria.responsibleName" | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="responsibleName" />
      </mat-form-field>
    </div>


    <div class="col-sm-6 date mb-2">
      <mat-label class="font-weight-bold field-required">
        {{ "forms.common.Criteria.endDate" | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="endPicker" (click)="endPicker.open()" formControlName="endDate" readonly>
        <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-sm-12 mb-2">
      <mat-label class="font-weight-bold field-required">
        {{ "forms.common.Criteria.requiredResources" | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" formControlName="requiredResources"></textarea>
      </mat-form-field>
    </div>

    <div class="col-sm-12 mb-2">
      <mat-label class="font-weight-bold field-required">
        {{ "forms.common.Criteria.expectedOutputs" | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" formControlName="expectedOutputs"></textarea>
      </mat-form-field>
    </div>

    <div class="col-sm-12 d-flex flex-column">
      <mat-label class="font-weight-bold">
        {{ "forms.common.Criteria.Attachments" | translate }}
      </mat-label>
      <formio #forms style="margin-top: {{data.viewOnly ? '0' : '-50px'}};"
        [submission]="{ data: { attachments: attachments }}" [formKey]="attachmentFormKey"
        [showLoader]="false" [readOnly]="data.viewOnly" [viewOnly]="data.viewOnly"
        (formLoad)="registerFormioEvent($event)">
      </formio>
    </div>

    <div class="col-sm-12 mt-2 d-flex justify-content-end">
      <button mat-flat-button (click)="cancel()" [ngClass]="{'mx-2': !data.viewOnly}">
        {{ "forms.common.cancel" | translate }}
      </button>
      <button *ngIf="!data.viewOnly" mat-flat-button (click)="save()" color="primary" [disabled]="form.invalid">
        {{ "forms.common.Criteria.save" | translate }}
      </button>
    </div>
  </div>
</form>